<template>
  <v-sheet height="100%" color="bg1" width="100%">
    <v-sheet height="100%" class="rounded-tl-lg overflow-hidden pa-4">
      <div
        class="pa-2 d-flex align-center"
        style="gap: 8px"
        :class="{
          'flex-wrap': $vuetify.breakpoint.xs,
        }">
        <h3>General Settings</h3>
      </div>
      <div class="pa-4">
       
        <div class="row-input">
          <div style="width: 250px">Active A-MIS</div>
          <v-switch
            :disabled="!allowUpdate"
            color="primary"
            v-model="forgeSettings.isAMIS"
            @change="toggleIsAMIS($event)"></v-switch>
        </div>
        <div v-has="permissions.GeneralSettings.Update" class="row-input">
          <div style="width: 250px">ShareFile Path</div>
          <div style="width: 30%; margin-right: 100px">{{ shareFilePath }}</div>
          <v-btn width="200" @click="editShareFilePath()" color="primary">Edit</v-btn>
        </div>
      </div>
    </v-sheet>
  </v-sheet>
</template>

<script>
  import { toggleExpandComponent } from '@/scripts/js/forgeviewer';
  import { postDataAsync } from '@/utils/mongoUtils';
  import HttpService from '@/utils/httpService';
  import permissions from '@Share/config/permissions';
  import { $has } from '@/utils';
  // import CountProgress from '@Company/components/CountProgress.vue';
  export default {
    name: 'AdminGeneralSettings',
    // components: {
    //   CountProgress,
    // },
    data() {
      return {
        permissions,
        isExpanded: false,
        modelUploadLimit: 0,
      };
    },
    methods: {
      toggleExpanded() {
        toggleExpandComponent(this);
      },
      editShareFilePath() {
        this.$store.state.shareFilePopupInfo.id = this.$store.state.forgeSettings.shareFileParentId;
        this.$store.state.shareFilePopupInfo.shown = true;
      },
      saveModelUploadLimitsDb() {
        HttpService.post({
          url: 'api/forge/settings/updateModelUploadLimit',
          data: { assetId: this.$route.params.id, modelUploadLimit: this.modelUploadLimit },
        })
          .then(() => {
            this.$store.state.forgeSettings.modelUploadLimit = this.modelUploadLimit;
          })
          .catch(() => {
            this.modelUploadLimit = this.$store.state.forgeSettings.modelUploadLimit;
            this.$dialog.notify.warning('Invalid value.', {
              position: 'top-right',
              timeout: 3000,
            });
          });
      },
      toggleIsAMIS() {
        postDataAsync('api/forge/settings/updateIsAMISOn', {
          assetId: this.$route.params.id,
          IsAMIS: this.forgeSettings.isAMIS,
        });
      },
    },
    mounted() {
      if (this.forgeSettings && this.forgeSettings.modelUploadLimit) {
        this.modelUploadLimit = this.forgeSettings.modelUploadLimit;
      } else {
        this.modelUploadLimit = 0;
      }
    },
    computed: {
      localModelUploadLimit: function () {
        let limit = this.$store.state.forgeSettings.modelUploadLimit || 0;
        const used = this.modelsCount;
        if (limit < used) limit = used;
        return limit;
      },
      modelsCount() {
        const models = this.$store.state.uploadedModels;
        return Array.isArray(models) ? models.length : 0;
      },
      forgeSettings() {
        return this.$store.state.forgeSettings;
      },
      disableSave: function () {
        return (
          isNaN(this.modelUploadLimit) ||
          this.modelUploadLimit == '' ||
          this.modelUploadLimit < 0 ||
          this.$store.state.forgeSettings.modelUploadLimit == this.modelUploadLimit
        );
      },
     
      shareFilePath() {
        return this.forgeSettings.shareFileParentId;
      },
      allowUpdate() {
        return $has(permissions.GeneralSettings.Update);
      },
    },
    watch: {
      forgeSettings: {
        handler: function (newValue, oldValue) {
          if (newValue != oldValue) {
            this.modelUploadLimit = newValue.modelUploadLimit;
          }
        },
        deep: true,
      },
    },
  };
</script>

<style>
  .model-uploads-section .row-input {
    justify-content: flex-start;
    padding: 10px 40px;
    gap: 10px;
  }

  .model-uploads-section input {
    height: 30px;
  }

  .model-uploads-section .admin-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 5px 0px;
    width: 200px;
    height: 20px;
  }

  .admin-btn.disabled {
    background: var(--v-primary-lighten3);
    pointer-events: none;
  }

  .model-uploads-section input::-webkit-outer-spin-button,
  .model-uploads-section input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
</style>
